import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import './Dropdown.scss';

export default class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showItem': false,
      'readOnly': props.readOnly ? true : false,
    };
    this.dropdown = createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutSide);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { readOnly } = this.props;

    if (nextProps.readOnly !== readOnly) {
      this.setState({ 'readOnly': nextProps.readOnly });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutSide = event => {
    if (this.dropdown.current && !this.dropdown.current.contains(event.target)) {
      return this.setState({ 'showItem': false });
    }
    return;
  }

  handleShowItem = () => {
    const { readOnly } = this.state;
    const { disabled } = this.props;

    if (!readOnly && !disabled) {
      this.setState({ 'showItem': !this.state.showItem });
    }
    return null;
  }

  render() {
    const { valueShow, value, placeholder, template, children, error, id, icon, className, disabled } = this.props;
    const { showItem, readOnly } = this.state;

    if (template && icon) {
      return (
        <div
          className={`Dropdown${template ? ` template-${template}` : ''}${showItem ? ' active' : ''}${className ? ` ${className}` : ''}`}
          ref={this.dropdown}
        >
          <div id={id} className={`box-group-input${error ? ' error' : ''}${disabled ? ' disabled' : ''}`} onClick={this.handleShowItem}>
            <span className={`icon ${icon}`} />
            <span className={value ? 'text' : 'placeholder'}>
              {value ? valueShow : placeholder}
            </span>
          </div>
          <div className={`box-items${showItem ? ' active' : ''}`}>
            {children}
          </div>
        </div>
      );
    }

    return (
      <div className={`Dropdown${template ? ` template-${template}` : ''}${showItem ? ' active' : ''}${className ? ` ${className}` : ''}`} ref={this.dropdown}>
        <div id={id} className={`box-group-input${error ? ' error' : ''}${disabled ? ' disabled' : ''}`} onClick={this.handleShowItem}>
          <span className="item-value">
            {
              valueShow || value ?
                <span className={`value${readOnly ? ' disabled' : ''}`}>{valueShow ? valueShow : value}</span>
                : <span className="placeholder">{placeholder}</span>
            }
          </span>
          <span className={`box-icon${readOnly ? ' disabled' : ''}`}>
            <span className="icon fas fa-chevron-down" />
          </span>
        </div>
        <div className={`box-items${showItem ? ' active' : ''}`}>
          {children}
        </div>
      </div>
    );
  }
}

Dropdown.propTypes = {
  'value': PropTypes.any,
  'valueShow': PropTypes.any,
  'placeholder': PropTypes.string,
  'item': PropTypes.array,
  'template': PropTypes.string,
  'children': PropTypes.any,
  'error': PropTypes.bool,
  'readOnly': PropTypes.bool,
  'id': PropTypes.string,
  'icon': PropTypes.string,
  'className': PropTypes.string,
  'disabled': PropTypes.bool,
};
